import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';
import ApplyButton from './ApplyButton';
import OnedriveButton from './OnedriveButton';
import { FilterDialog } from './FilterDialog';
import { GroupByDialog } from './GroupByDialog';
import OpStructuresDialog from './OpStructuresDialog';

export interface ReportFilterActionsProps {
  applyDisabled?: boolean;
  beforeApply?: () => boolean;
  children?: ReactNode;
  // onedriveDisabled={onedriveDisabled}
}

export const ActionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'right',

  '& > button': {
    marginRight: theme.spacing(2),
  },

  '& > span': {
    marginRight: theme.spacing(2),
  },

  '& > button:last-of-type': {
    marginRight: 0,
  },

  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

const ReportFilterActions = ({
  applyDisabled,
  children,
  beforeApply,
}: ReportFilterActionsProps) => (
  <ActionContainer>
    {children}
    <OpStructuresDialog />
    <FilterDialog />
    <GroupByDialog />
    <ApplyButton disabled={applyDisabled} beforeApply={beforeApply} />
    <OnedriveButton disabled={applyDisabled} />
  </ActionContainer>
);

export default ReportFilterActions;
